"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var DrillMeasureSelectorItem = function (props) {
    var onClick = function () {
        props.onClick(props.item);
        props.onCloseDropdown();
    };
    var name = props.item.measure.measureHeaderItem.name;
    return (react_1.default.createElement("a", { onClick: onClick, className: "gd-drill-measure-selector-list-item s-drill-measure-selector-item", title: name }, name));
};
exports.default = DrillMeasureSelectorItem;
//# sourceMappingURL=DrillMeasureSelectorItem.js.map